import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetProxiesByOrderResponse } from "./GetProxiesByOrderResponse";

export const useOrderProxyApi = () => {
    const { httpGet } = useAuthorizedFetch();

    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/proxies`;

    const getProxiesByOrder = async (orderId: string): Promise<GetProxiesByOrderResponse> => {
        return httpGet<GetProxiesByOrderResponse>(`${baseUrl}/get-by-order`, { orderId });
    };

    return {
        getProxiesByOrder
    };
};
